import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { useRoutes } from '../../context/routesContext';
import translateObj from '../../util/translateObj';

const PARSER_OPTIONS = {
  replace: (domNode) => {
    if (domNode?.name === 'script') {
      const script = document.createElement('script');
      script.src = domNode.attribs.src;
      document.head.appendChild(script);
    }
  },
};

const Embed = ({ code, useLang }) => {
  const { language } = useRoutes();
  let codeFromDb = translateObj(code, language);

  // Add lang parameter to URLs in the HTML if useLang is true
  if (useLang && language) {
    // Replace URLs in src attributes with lang parameter
    codeFromDb = codeFromDb.replace(
      /src="([^"]+)"/g,
      (match, url) => {
        const separator = url.includes('?') ? '&' : '?';
        return `src="${url}${separator}lang=${language}"`;
      },
    );
  }

  return (
    <div className="w-full">
      {parse(codeFromDb, PARSER_OPTIONS)}
    </div>
  );
};

export default Embed;

Embed.propTypes = {
  code: PropTypes.shape({
    en: PropTypes.string,
    es: PropTypes.string,
    ca: PropTypes.string,
    pt: PropTypes.string,
  }),
  useLang: PropTypes.bool,
};

Embed.defaultProps = {
  code: {},
  useLang: false,
};
